import React, {useEffect} from 'react';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowRight } from '../styles/icon/arrowRight.svg';
import breadcrmbs from './Breadcrumbs.module.scss';

function fixForAttribute(attrib) {
    const baseUrl = window.location.href;

    [].slice.call(document.querySelectorAll(`svg [${attrib}]`))
        .filter((element: SVGElement) => element.getAttribute(attrib).indexOf('url(#') === 0)
        .forEach((element: SVGElement) => {
            const maskId = element.getAttribute(attrib).replace('url(', '').replace(')', '');
            element.setAttribute(attrib, `url(${baseUrl + maskId})`);
        });
}

function Breadcrumbs(props) {
  const {breadcrumbs} = props;
  useEffect(() => {
      fixForAttribute('fill');
  },[]);
  const _breadcrumbs = breadcrumbs.filter(({breadcrumb}) => (!breadcrumb.key.startsWith('/apps/') || !/^\d+$/.test(breadcrumb.props.children)));
  return (
      <div className={breadcrmbs.breadcrmbs}>
          {_breadcrumbs && _breadcrumbs.map(({breadcrumb, match}, i) => {
            const isFirst = i === 0;
            const isLast = i === _breadcrumbs.length - 1;
            return (
                <span key={i}>
                  {!isFirst && <ArrowRight/>}
                    {isLast ? (
                        <span className={breadcrmbs.breadcrmbs__active}>{breadcrumb}</span>
                    ) : (
                        <Link to={match.path}>{breadcrumb}</Link>
                    )}
                </span>
            );
          })}
      </div>
  )
}



export default React.memo(
  withBreadcrumbs([
    // {
    //   path: '/',
    //   breadcrumb: 'my home!'
    // },
    // {
    //   path: '/apps',
    //   breadcrumb: 'apps page'
    // },
    // {
    //   path: '/doc',
    //   breadcrumb: ' doc page',
    //   routes: [
    //       {
    //         path: '/doc/overview',
    //         breadcrumb: 'overview page'
    //       }
    //   ]
    // }
    {
      path: '/sdks',
      breadcrumb: 'SDKs',
    },
    {
      path: '/api',
      breadcrumb: 'APIs',
    },
    {
      path: '/apps',
      breadcrumb: 'Apps',
    },
  ])(Breadcrumbs)
);
